export default __webpack_public_path__ + "static/media/friendsNcake_w1024.774e7b46.jpeg";